import { z } from 'zod';
import { UUIDSchema } from '../ids.js';
// F2: per-row controller-sync state. Mirrors the Prisma SyncStatus enum
// used elsewhere (employees, credentials, schedules).
export const VendorAccessSyncStatusSchema = z.enum([
    'pending',
    'synced',
    'failed',
    'retry',
]);
export const VendorAccessSchema = z.object({
    id: UUIDSchema,
    tenant_id: UUIDSchema,
    name: z.string(),
    phone: z.string().nullable(),
    purpose: z.string().nullable(),
    valid_from: z.string(),
    valid_until: z.string(),
    access_group_id: UUIDSchema,
    pin_credential_id: UUIDSchema.nullable(),
    // F2: controller-side sync. Populated by the grant flow. The
    // grant route returns the full PIN ONCE in its response; the portal
    // only persists the last 4 digits for later operator re-identification.
    unifi_user_id: UUIDSchema.nullable(),
    unifi_credential_id: z.string().nullable(),
    pin_code_last4: z.string().nullable(),
    sync_status: VendorAccessSyncStatusSchema,
    last_sync_error: z.string().nullable(),
    last_sync_at: z.string().nullable(),
    // Nullable because of `onDelete: SetNull` on the User FK — deleting
    // an operator who once granted access leaves the historical row
    // intact with a null actor here (audit log retains the original
    // actor ID for tamper-evidence).
    created_by_user_id: UUIDSchema.nullable(),
    revoked_at: z.string().nullable(),
    revoked_by_user_id: UUIDSchema.nullable(),
    revoked_reason: z.string().nullable(),
    created_at: z.string(),
    updated_at: z.string(),
});
/** Grant response includes the full PIN ONCE; subsequent GETs do not. */
export const GrantVendorAccessResponse = VendorAccessSchema.extend({
    pin_code: z.string().nullable(),
});
export const CreateVendorAccessBody = z
    .object({
    name: z.string().trim().min(1).max(120),
    phone: z.string().trim().max(40).optional(),
    purpose: z.string().trim().max(500).optional(),
    valid_from: z.string().datetime(),
    valid_until: z.string().datetime(),
    access_group_id: UUIDSchema,
})
    .refine((b) => new Date(b.valid_until) > new Date(b.valid_from), {
    message: 'valid_until must be after valid_from',
    path: ['valid_until'],
});
export const RevokeVendorAccessBody = z.object({
    reason: z.string().trim().min(1).max(500),
});
export function vendorAccessStatus(row, now = new Date()) {
    if (row.revoked_at)
        return 'revoked';
    const start = new Date(row.valid_from);
    const end = new Date(row.valid_until);
    if (now < start)
        return 'pending';
    if (now > end)
        return 'expired';
    return 'active';
}
//# sourceMappingURL=vendor.js.map